import { FavoriteMedicineToFavoriteStandardMedicineStruct } from "../../structs/medic/favorite-medicine-to-favorite-standard-medicine.struct";

export class FavoriteMedicatedSolutionStruct {
    public listMedicine: FavoriteMedicineToFavoriteStandardMedicineStruct[] = [];

    public idDilutionUnit: number;
    public idSubFrequency: number;
    public idMedicFavoriteStandardPrescription: number;
    public idAdministrationType: number;
    public idDilution: number;
    public idFrequency: number;
    public idPresentation: number;
    public idFavoriteMedicatedSolution: number;
    public idTreatmentPeriod: number;
    public idUsage: number;

    public administrationTypeName: string;
    public administrationType: string;
    public dilution: string;
    public dilutionName: string;
    public frequencyName: string;
    public presentation: string;
    public presentationName: string;
    public treatmentPeriodName: string;
    public usage: string;
    public subFrequencyName: string;
    public dilutionQuantity: string;
    public dilutionUnitName: string;
    public observation: string;
}